// any number of ( [leading commas] + [pairs of backticks surrounding any value] ) + trailing commas
export const INSTANCE_BACKTICKS_MATCHER = /^(?:,*`[^`]*`)*,*$/;

// leading commas + [iri] + any number of ( [at least one comma] + [iri] ) + trailing commas
export const INSTANCE_COMMAS_MATCHER = /^,*(?:`[^`]*`)(?:,+`[^`]*`)*,*$/;
